/**
 * 任务调度设置接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ScheduleTaskManageService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region scheduleTask 任务调度设置接口
  /**
   * 查询任务调度列表
   * @param param
   * @returns {Observable<any>}
   */
  getScheduleTaskList(param) {
    const url = this.schedulefix + 'schedule/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 添加任务调度
   * @param param
   * @returns {Observable<any>}
   */
  saveScheduleTask(param) {
    const url = this.schedulefix + 'schedule/save';
    return this.http.Post(url, param);
  }

  /**
   * 修改任务调度
   * @param param
   * @returns {Observable<any>}
   */
  updateScheduleTask(param) {
    const url = this.schedulefix + 'schedule/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 查询任务调度
   * @param param
   * @returns {Observable<any>}
   */
  getScheduleTaskById(param) {
    const url = this.schedulefix + 'schedule/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 删除任务调度
   * @param param
   * @returns {Observable<any>}
   */
  deleteScheduleTaskById(param) {
    const url = this.schedulefix + 'schedule/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 暂停任务
   * @param param
   * @returns {Observable<any>}
   */
  pauseScheduleTask(param) {
    const url = this.schedulefix + 'job/pauseJob';
    return this.http.Post(url, param);
  }

  /**
   * 恢复任务
   * @param param
   * @returns {Observable<any>}
   */
  resumeScheduleTask(param) {
    const url = this.schedulefix + 'job/resumeJob';
    return this.http.Post(url, param);
  }

  //计划任务执行记录查询
  queryPageList(param){
    const url = this.schedulefix + 'scheduleHistory/queryPageList';
    return this.http.Post(url, param);
  }

  //修复触发器
  repairTrigger(param){
    const url = this.schedulefix + 'job/repairTrigger?'+param;
    return this.http.Get(url);
  }
  //#endregion

}
